import { render, staticRenderFns } from "./DeliveryShansong.vue?vue&type=template&id=d681e12e&scoped=true&"
import script from "./DeliveryShansong.vue?vue&type=script&lang=js&"
export * from "./DeliveryShansong.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryShansong.vue?vue&type=style&index=0&id=d681e12e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d681e12e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\CRM\\Client2026\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d681e12e')) {
      api.createRecord('d681e12e', component.options)
    } else {
      api.reload('d681e12e', component.options)
    }
    module.hot.accept("./DeliveryShansong.vue?vue&type=template&id=d681e12e&scoped=true&", function () {
      api.rerender('d681e12e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cms/delivery/components/DeliveryShansong.vue"
export default component.exports